var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "fullWareReceupt" } }, [
    _vm.deviceType == "tablet" || _vm.deviceType == "desktop"
      ? _c("div", { staticClass: "warehouse_PC" }, [
          _c("div", { staticClass: "warehouse_PC_con" }, [
            _c("div", { staticClass: "warehouse_PC_head" }, [
              _vm._v("整柜-入库单")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehosue_PC_warning" }, [
              _c(
                "div",
                { staticClass: "warehouse_warning_chose" },
                [
                  _vm._v("\n          语言/language:     "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.languageType == "CN" ? "primary" : "default"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLang("CN")
                        }
                      }
                    },
                    [_vm._v("中文")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.languageType == "EN" ? "primary" : "default"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLang("EN")
                        }
                      }
                    },
                    [_vm._v("English")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "warehouse_warn_words" }, [
                _vm._v(
                  "\n          注意:  请务必认真填写货值并提交确认,此信息具有法律效应!\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehouse_in_order" }, [
              _c("div", { staticClass: "warehouse_orders" }, [
                _c("div", { staticClass: "warehouse_orders_item" }, [
                  _c("div", { staticClass: "warehouse_item_title" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          flex: "1",
                          "flex-direction": "row",
                          "align-items": "center"
                        }
                      },
                      [
                        _vm._v(
                          "\n                客户简称:   " +
                            _vm._s(_vm.customer) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "warehouse_orders_con" }, [
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v("单号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.languageType == "EN"
                              ? _vm.submitForm.nos.en
                              : _vm.submitForm.nos.cn
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v("起运港")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.languageType == "EN"
                              ? _vm.submitForm.departureEnPort.en
                              : _vm.submitForm.departureEnPort.cn
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v("目的港")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.languageType == "EN"
                              ? _vm.submitForm.destinationEnPort.en
                              : _vm.submitForm.destinationEnPort.cn
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v("件数")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.languageType == "EN"
                              ? _vm.submitForm.piece.en
                              : _vm.submitForm.piece.cn
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warehouse_con_son" }, [
                      _vm._v("柜号")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "warehouse_con_son",
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          gap: "10px"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.languageType == "EN"
                                ? _vm.submitForm.cntNo.en
                                : _vm.submitForm.cntNo.cn
                            ) +
                            "\n                "
                        ),
                        _vm.submitForm.isConfirm.en != 1
                          ? _c("el-input", {
                              staticClass: "input_num",
                              on: {
                                input: function($event) {
                                  return _vm.handleInput(_vm.confirmWords[0], 0)
                                }
                              },
                              model: {
                                value: _vm.confirmWords[0],
                                callback: function($$v) {
                                  _vm.$set(_vm.confirmWords, 0, $$v)
                                },
                                expression: "confirmWords[0]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.submitForm.isConfirm.en != 1
                          ? _c("el-input", {
                              staticClass: "input_num",
                              on: {
                                input: function($event) {
                                  return _vm.handleInput(_vm.confirmWords[1], 1)
                                }
                              },
                              model: {
                                value: _vm.confirmWords[1],
                                callback: function($$v) {
                                  _vm.$set(_vm.confirmWords, 1, $$v)
                                },
                                expression: "confirmWords[1]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.submitForm.isConfirm.en != 1
                          ? _c("el-input", {
                              staticClass: "input_num",
                              on: {
                                input: function($event) {
                                  return _vm.handleInput(_vm.confirmWords[2], 2)
                                }
                              },
                              model: {
                                value: _vm.confirmWords[2],
                                callback: function($$v) {
                                  _vm.$set(_vm.confirmWords, 2, $$v)
                                },
                                expression: "confirmWords[2]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.submitForm.isConfirm.en != 1
                          ? _c("el-input", {
                              staticClass: "input_num",
                              on: {
                                input: function($event) {
                                  return _vm.handleInput(_vm.confirmWords[3], 3)
                                }
                              },
                              model: {
                                value: _vm.confirmWords[3],
                                callback: function($$v) {
                                  _vm.$set(_vm.confirmWords, 3, $$v)
                                },
                                expression: "confirmWords[3]"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "warehouse_con_son",
                        staticStyle: { color: "rgb(224, 0, 17)" }
                      },
                      [_vm._v("\n                货值(USD)\n              ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "warehouse_con_son" },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            type: "number",
                            placeholder: "请填写货值金额"
                          },
                          on: {
                            input: function($event) {
                              return _vm.handleUsdInput(
                                _vm.submitForm.goodsValue.en
                              )
                            }
                          },
                          model: {
                            value: _vm.submitForm.goodsValue.en,
                            callback: function($$v) {
                              _vm.$set(_vm.submitForm.goodsValue, "en", $$v)
                            },
                            expression: "submitForm.goodsValue.en"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "warehouse_con_son",
                        staticStyle: { color: "rgb(224, 0, 17)" }
                      },
                      [_vm._v("\n                提交人\n              ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "warehouse_con_son" },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请填写提交人" },
                          on: {
                            input: function($event) {
                              return _vm.handleSonInput(
                                _vm.submitForm.commit.en
                              )
                            }
                          },
                          model: {
                            value: _vm.submitForm.commit.en,
                            callback: function($$v) {
                              _vm.$set(_vm.submitForm.commit, "en", $$v)
                            },
                            expression: "submitForm.commit.en"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.submitForm.isConfirm.en != 1
              ? _c("div", { staticClass: "warehouse_PC_bottom" }, [
                  _c(
                    "div",
                    { staticClass: "warehouse_bottom_second" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.submitFormVal(false)
                            }
                          }
                        },
                        [_vm._v("保存")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.submitFormVal(true)
                            }
                          }
                        },
                        [_vm._v("确认并提交")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.deviceType == "mobile"
      ? _c("div", { staticClass: "warehouse_Mobile" }, [
          _c("div", { staticClass: "warehouse_Mobile_title" }, [
            _vm._v("入库单确认")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "warehouse_Mobile_con" }, [
            _c("div", { staticClass: "warehouse_Mobile_lang" }, [
              _vm._v("\n        语言(Language):\n        "),
              _c(
                "div",
                {
                  class: {
                    Mobile_chose_btn: true,
                    Mobile_btn_active: _vm.languageType == "CN"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeLang("CN")
                    }
                  }
                },
                [_vm._v("\n          中文\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    Mobile_chose_btn: true,
                    Mobile_btn_active: _vm.languageType == "EN"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeLang("EN")
                    }
                  }
                },
                [_vm._v("\n          English\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehouse_inOrder_list" }, [
              _c("ul", { staticClass: "warehouse_inOrder_ul" }, [
                _c("li", { staticClass: "warehouse_inOrder_li" }, [
                  _c("div", { staticClass: "inOrder_li_cus" }, [
                    _vm._v("客户:" + _vm._s(_vm.customer))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inOrder_li_form" }, [
                    _c("div", [
                      _c("div", [_vm._v("单号")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.languageType == "EN"
                                ? _vm.submitForm.nos.en
                                : _vm.submitForm.nos.cn
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_vm._v("起运港")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.languageType == "EN"
                                ? _vm.submitForm.departureEnPort.en
                                : _vm.submitForm.departureEnPort.cn
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_vm._v("目的港")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.languageType == "EN"
                                ? _vm.submitForm.destinationEnPort.en
                                : _vm.submitForm.destinationEnPort.cn
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_vm._v("件数")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.languageType == "EN"
                                ? _vm.submitForm.piece.en
                                : _vm.submitForm.piece.cn
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_vm._v("柜号")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "boxNum",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            gap: "10px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? _vm.submitForm.cntNo.en
                                  : _vm.submitForm.cntNo.cn
                              ) +
                              "\n                  "
                          ),
                          _vm.submitForm.isConfirm.en != 1
                            ? _c("el-input", {
                                staticClass: "input_num",
                                on: {
                                  input: function($event) {
                                    return _vm.handleInput(
                                      _vm.confirmWords[0],
                                      0
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.confirmWords[0],
                                  callback: function($$v) {
                                    _vm.$set(_vm.confirmWords, 0, $$v)
                                  },
                                  expression: "confirmWords[0]"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.submitForm.isConfirm.en != 1
                            ? _c("el-input", {
                                staticClass: "input_num",
                                on: {
                                  input: function($event) {
                                    return _vm.handleInput(
                                      _vm.confirmWords[1],
                                      1
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.confirmWords[1],
                                  callback: function($$v) {
                                    _vm.$set(_vm.confirmWords, 1, $$v)
                                  },
                                  expression: "confirmWords[1]"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.submitForm.isConfirm.en != 1
                            ? _c("el-input", {
                                staticClass: "input_num",
                                on: {
                                  input: function($event) {
                                    return _vm.handleInput(
                                      _vm.confirmWords[2],
                                      2
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.confirmWords[2],
                                  callback: function($$v) {
                                    _vm.$set(_vm.confirmWords, 2, $$v)
                                  },
                                  expression: "confirmWords[2]"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.submitForm.isConfirm.en != 1
                            ? _c("el-input", {
                                staticClass: "input_num",
                                on: {
                                  input: function($event) {
                                    return _vm.handleInput(
                                      _vm.confirmWords[3],
                                      3
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.confirmWords[3],
                                  callback: function($$v) {
                                    _vm.$set(_vm.confirmWords, 3, $$v)
                                  },
                                  expression: "confirmWords[3]"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_vm._v("货值金额")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "mobile_money",
                              attrs: {
                                clearable: "",
                                type: "number",
                                placeholder: "请填写货值金额"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.handleUsdInput(
                                    _vm.submitForm.goodsValue.en
                                  )
                                }
                              },
                              model: {
                                value: _vm.submitForm.goodsValue.en,
                                callback: function($$v) {
                                  _vm.$set(_vm.submitForm.goodsValue, "en", $$v)
                                },
                                expression: "submitForm.goodsValue.en"
                              }
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("USD")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mobile_submit_bottom",
                style: {
                  height: _vm.submitForm.isConfirm.en != 1 ? "120px" : "50px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "mobile_submit_man" },
                  [
                    _c("div", { staticClass: "mobile_submit_contact" }, [
                      _vm._v("提交人")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "请填写提交人" },
                      on: {
                        input: function($event) {
                          return _vm.handleSonInput(_vm.submitForm.commit.en)
                        }
                      },
                      model: {
                        value: _vm.submitForm.commit.en,
                        callback: function($$v) {
                          _vm.$set(_vm.submitForm.commit, "en", $$v)
                        },
                        expression: "submitForm.commit.en"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.submitForm.isConfirm.en != 1
                  ? _c(
                      "div",
                      { staticClass: "mobile_submit_btns" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.submitFormVal(false)
                              }
                            }
                          },
                          [_vm._v("保存")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.submitFormVal(true)
                              }
                            }
                          },
                          [_vm._v("确认并提交")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warehouse_Mobile_warning" }, [
      _c("i", {
        staticClass: "el-icon-warning",
        staticStyle: { color: "#ee3330" }
      }),
      _vm._v(
        "\n      注意:请务必认真填写货值并提交确认,此信息具有法律效应!\n    "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42502ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42502ea8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsValue/fullWareReceipt.vue
// module id = null
// module chunks = 